// Utility function to get the next Thursday at 7:00 PM EST
export function getNextThursday7PM(): Date {
  const now = new Date()

  // Convert current time to EST (UTC-5)
  const estOffset = -5 * 60 // EST is UTC-5
  const utcTime = now.getTime() + now.getTimezoneOffset() * 60000
  const estTime = new Date(utcTime + estOffset * 60000)

  // Get current day, month, and year in EST
  const currentDay = estTime.getDay() // 0 = Sunday, 4 = Thursday
  const currentHour = estTime.getHours()
  const currentDate = estTime.getDate()
  const currentMonth = estTime.getMonth()
  const currentYear = estTime.getFullYear()

  let daysUntilThursday = 0

  if (currentDay === 4) {
    // It's Thursday
    if (currentHour < 19) {
      // Before 7 PM, use today
      daysUntilThursday = 0
    } else {
      // After 7 PM, use next Thursday
      daysUntilThursday = 7
    }
  } else if (currentDay < 4) {
    // Before Thursday this week
    daysUntilThursday = 4 - currentDay
  } else {
    // After Thursday this week (Friday, Saturday, Sunday)
    daysUntilThursday = 7 - currentDay + 4
  }

  // Create the target date in EST
  const targetDate = new Date(
    currentYear,
    currentMonth,
    currentDate + daysUntilThursday,
    19,
    0,
    0,
    0,
  )

  return targetDate
}

// Format date in Spanish (e.g., "Jueves, 29 de Enero")
export function formatSpanishDate(date: Date): string {
  const months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ]

  const day = date.getDate()
  const month = months[date.getMonth()]

  return `Jueves, ${day} de ${month}`
}
